import 'Src/basic/new-boot/index'
import Apps from 'Src/pagelets/login.vue'
Vue.config.devtools = true

export default new Vue({
  el: '#app',
  render: creator => creator(Apps)
})
